enum DashboardTypes {
    BASIC = "basic",
    TEAM = "team",
    RANKING = "ranking",
    LASSO = "lasso",
    BENCHMARK = "benchmark",
    TEAM_SESSION = "teamSession",
    BOARD_SCAN = "boardScan",
    REFLECTION_TEXT = "reflectionText",
}

export type DashboardType = DashboardTypes;

export default DashboardTypes;
